import {
    useCallback,
} from 'react'
import sortBy from 'lodash/sortBy'

import {
    OperationalHour,
} from '../../serviceCenters.types'
import OperationalDays from './OperationalDays'

const order = [
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
    'SUNDAY',
]

const OperationalDaysContainer = ({
    value,
    onChange,
    className = '',
}: Readonly<{
    value: OperationalHour[],
    onChange: (val: OperationalHour[]) => void,
    className?: string,
}>) => {
    const onItemChange = useCallback((newVal: OperationalHour) => {
        const updatedVal = value?.map((item) => {
            if (item.dayOfWeek === newVal.dayOfWeek) {
                return newVal.isOperational ? newVal : {
                    ...newVal,
                    workStartsAt: undefined,
                    workEndsAt: undefined,
                }
            }
            return item
        })

        onChange(updatedVal)
    }, [
        onChange,
        value,
    ])

    return (
        <div className={className}>
            {sortBy(value, ({
                dayOfWeek,
            }) => { return order.indexOf(dayOfWeek) }).map((item) => {
                return (
                    <OperationalDays
                        value={item}
                        onChange={onItemChange}
                        key={item.dayOfWeek}
                    />
                )
            })}
        </div>
    )
}

export default OperationalDaysContainer
